import { render, staticRenderFns } from "./TituloList.vue?vue&type=template&id=2c96dc4c&scoped=true&"
import script from "./TituloList.vue?vue&type=script&lang=js&"
export * from "./TituloList.vue?vue&type=script&lang=js&"
import style0 from "./TituloList.vue?vue&type=style&index=0&id=2c96dc4c&lang=scss&scoped=true&"
import style1 from "./TituloList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96dc4c",
  null
  
)

export default component.exports